const UserContactField = ({ user }) => <div>{ user.email ? <a href={ `mailto:${ user.email }` }>{ user.email }</a> : <strong>&mdash;</strong> }</div>;



export default UserContactField;